import { usePlaybackTimerPause } from "../playback";

export function useUpdatePanelBuffering(isBuffering: boolean) {
  usePlaybackTimerPause(isBuffering);
}
